import React from 'react';
import { Label } from '@core/js/components/common/Fields/Label';
import { clsb, clsx } from '@core/js/utils/classNames.util';
import { ErrorMessage } from '@core/js/components/common/ErrorMessage';

import * as helpers from '@core/js/components/common/Fields/Control/helpers';

import style from './Control.scss';

export const Control = ({
    id,
    meta: { active, touched, submitting, validating, submitError, error = submitError, customError } = {},
    label,
    hint,
    readOnly,
    classNames = {},
    className = '',
    onClick,
    animate,
    children,
    bottomHint,
    disabled = false,
    isBorderHidden = false,
    infoTooltip = '',
    isLabelAsteriskEnabled = false,
    ...props // data attributes
}) => {
    const modeClassName = helpers.getModeClass({
        error: customError || error, touched,
        active, submitting, validating, disabled, readOnly
    });
    const controlClassName = clsb([style, classNames], ['control', modeClassName]);

    return (
        <div
            onClick={onClick}
            /* TotalCasino changes */
            className={clsx([
                controlClassName,
                disabled && classNames?.disabled,
                readOnly && classNames?.readOnly,
                isBorderHidden && classNames?.hideBorder,
                isBorderHidden && style.hideBorder,
                className,
                `control-${modeClassName}`
            ])}
        >
            {(label || isLabelAsteriskEnabled) && (
                <Label
                    id={id}
                    hint={hint}
                    label={label}
                    readOnly={readOnly}
                    classNames={classNames}
                    isLabelAsteriskEnabled={isLabelAsteriskEnabled}
                />
            )}

            <div
                className={clsx([
                    clsb([style, classNames], ['content']),
                    'cms-control-content'
                ])}
                {...props}
            >
                {children}
            </div>
            {/* TotalCasino changes */}
            {infoTooltip && <div className={style.bottomTooltip}>{infoTooltip}</div>}

            {bottomHint && (
                <span className={clsb([style, classNames], ['bottomHint'])}>{bottomHint}</span>
            )}

            {(error && touched && !active && !validating || customError) && (
                <ErrorMessage
                    error={customError || error}
                    animate={animate}
                    classNames={{ error: style.error, ...classNames }}
                />
            )}
        </div>
    );
};
